import { TextLabel } from '@core/components/Inputs';
import { formatCNPJ } from '@format';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const optionsIndicador = [
  { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
  { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS ' },
  { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
];
const PessoaJuridica = (props) => {
  let { pessoaJuridica = {}, inscricaoMunicipal } = props;
  if (pessoaJuridica === null) {
    pessoaJuridica = {};
  }
  const { cnpj, razaoSocial, dataFundacao, indicadorInscricaoEstadual, inscricaoEstadual } = pessoaJuridica;

  const indicadorValue =
    indicadorInscricaoEstadual && optionsIndicador.find((op) => op.id === indicadorInscricaoEstadual).title;

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel label="CNPJ" id="pessoa.pessoaJuridica.cnpj" value={cnpj} format={formatCNPJ} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.pessoaJuridica.razaoSocial" label="Razão social" value={razaoSocial} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          id="pessoa.pessoaJuridica.dataFundacao"
          label="Data de fundação"
          value={dataFundacao}
          format={(value) => {
            if (value) {
              return moment(value).format('DD/MM/YYYY');
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          label="Indicador de inscrição estadual"
          id="pessoa.pessoaJuridica.indicadorInscricaoEstadual"
          value={indicadorValue}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.pessoaJuridica.inscricaoEstadual" label="Inscrição estadual" value={inscricaoEstadual} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.inscricaoMunicipal" label="Inscrição municipal" value={inscricaoMunicipal} />
      </Grid>
    </>
  );
};
export default PessoaJuridica;
